import { t } from "../../../../utils/i18n";
import React, { useEffect, useState } from "react";
import { getRequest } from "../../../../utils/httpRequest";

const CardDetail = ({ card }) => {
  useEffect(() => {
    getRequest(`/api/v1/cards/details/${card.id}/get_rain_card_balance`).then(
      (response) => {
        setBalance(response);
      }
    );
  }, []);

  const [balance, setBalance] = useState(null);

  return (
    <div className="card-body">
      <div className="form-horizontal card-inner-container pt-3 pb-3 pl-3 pr-2">
        <div className="form-group row">
          <label className="col-12 col-md-3 form-label font-weight-bold">
            {t("cards.details.card_number")}
          </label>
          <div className="col-12 col-md-9">
            <span
              data-controller="clipboard"
              data-clipboard-success-content-value={t("cards.common.copied")}
            >
              {card.last4}
              <input
                hidden={true}
                type="text"
                value={card.last4}
                data-clipboard-target="source"
              />
              <button
                className="p-0 border-0 copy-btn ml-1"
                style={{
                  background: "transparent !important",
                  outline: "none",
                }}
                data-action="clipboard#copy"
                data-toggle="tooltip"
                data-placement="top"
                title=""
                data-original-title={t("cards.common.copy_to_clipboard")}
              >
                <i className="fa fa-copy"></i>
              </button>
            </span>
          </div>
        </div>

        <div className="form-group row">
          <label className="col-12 col-md-3 form-label font-weight-bold">
            {t("cards.details.card_id")}
          </label>
          <div className="col-12 col-md-9">
            <span
              data-controller="clipboard"
              data-clipboard-success-content-value={t("cards.common.copied")}
            >
              {card.id}
              <input
                hidden={true}
                type="text"
                value={card.id}
                data-clipboard-target="source"
              />
              <button
                className="p-0 border-0 copy-btn ml-1"
                style={{
                  background: "transparent !important",
                  outline: "none",
                }}
                data-action="clipboard#copy"
                data-toggle="tooltip"
                data-placement="top"
                title=""
                data-original-title={t("cards.common.copy_to_clipboard")}
              >
                <i className="fa fa-copy"></i>
              </button>
            </span>
          </div>
        </div>

        <div className="form-group row">
          <label className="col-12 col-md-3 form-label font-weight-bold">
            {t("cards.details.card_balance")}
          </label>
          <div className="col-12 col-md-9">
            <span>$ {balance || 0}</span>
          </div>
        </div>

        <div className="form-group row">
          <label className="col-12 col-md-3 form-label font-weight-bold">
            {t("cards.common.status")}
          </label>
          <div className="col-12 col-md-9">
            <span className="text-info">
              <span className="card-det-status">{card.status}</span>
            </span>
          </div>
        </div>
      </div>
      <br />
      <div className="d-flex">
        <div className="ml-auto">
          <a className="btn btn-outline-purple" href="/cards/details">
            <i className="fa fa-arrow-left"></i> {t("cards.common.back")}
          </a>
        </div>
      </div>
    </div>
  );
};

export default CardDetail;
